// This is the webpack entry point
// Refrain from putting actual code in here and just import the modules you need; 
import LazyLoad from 'vanilla-lazyload';
import objectFitImages from 'object-fit-images';


import './nav';
import './tabs';
import './slider';
import './video';

// import AOS from 'aos';
// import 'aos/dist/aos.css';

// document.addEventListener('DOMContentLoaded', AOS.init);

// ((window) => {
//     window.addEventListener('DOMContentLoaded', e => {
//         window.lazyLoad = new LazyLoad({ threshold: 0 }, document.querySelectorAll('img'));
//     });
//     // lazy load
//     return window;
// })(window);

document.addEventListener('DOMContentLoaded', () => objectFitImages());
